import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAddProjectPermitTemplates = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['addProjectPermitTemplates']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.addProjectPermitTemplates,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        projectKeys.byId({ projectId: variables.projectId })._ctx
          .projectPermitTemplates._def,
      )
    },
  })
}
